import React from "react"
import { DrawerProvider } from "./drawer";
import { ModalProvider } from "./modal";

export default function ContextProvider({ children }) {
    return (
        <DrawerProvider>
            <ModalProvider>
                {children}
            </ModalProvider>
        </DrawerProvider>
    )

}
